import type { UnsplashImage } from '../../../types/auth';
import type { CoverUnsplashCredit } from './sessionWizardTypes';

/**
 * CORE-1381 — the Unsplash gallery on the web wizard's «Обложка» step.
 *
 * Pure (no React / RN imports), like `coverCropGeometry`, so the credit and the
 * referral links unit-test without a DOM.
 */

/** Unsplash API guidelines: every link back to Unsplash or to the photographer
 *  carries `utm_source=<app>&utm_medium=referral`. */
export const UNSPLASH_UTM_SOURCE = 'agapella';

export function unsplashReferralUrl(url: string): string {
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}utm_source=${UNSPLASH_UTM_SOURCE}&utm_medium=referral`;
}

export const UNSPLASH_HOME_URL = unsplashReferralUrl('https://unsplash.com/');

/** The part of a gallery item the draft keeps once it becomes the cover. */
export function unsplashCredit(img: UnsplashImage): CoverUnsplashCredit {
  return { id: img.id, authorName: img.authorName, authorUrl: img.authorUrl };
}
